import React, { useEffect } from "react";
import { AssistDecisionTree } from "../models";
import { useAssist } from "../../../context/AssistContext";

interface DecisionTreeViewerProps {
  tree: AssistDecisionTree;
}

export const DecisionTreeViewer: React.FC<DecisionTreeViewerProps> = ({ tree }) => {
  const { state, startDecisionTree, answerDecisionNode } = useAssist();
  const active = state.activeDecisionTree?.treeId === tree.id ? state.activeDecisionTree : undefined;

  useEffect(() => {
    if (!active) {
      startDecisionTree(tree);
    }
  }, [active, startDecisionTree, tree]);

  if (!active) {
    return (
      <div className="mm-surface p-4">
        <p className="text-sm text-slate-600 dark:text-slate-300">Chargement de l'arbre...</p>
      </div>
    );
  }

  const currentNode = tree.nodes.find((n) => n.id === active.currentNodeId);
  const result = active.resultId ? tree.results.find((r) => r.id === active.resultId) : undefined;

  return (
    <div className="mm-surface p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">{tree.title}</h3>
        {active.resultId && (
          <button
            type="button"
            onClick={() => startDecisionTree(tree)}
            className="text-sm px-3 py-1.5 rounded-lg border bg-white dark:bg-slate-900 dark:border-slate-700"
          >
            Recommencer
          </button>
        )}
      </div>
      <p className="text-sm text-slate-600 dark:text-slate-300">{tree.description}</p>

      {!result && currentNode && (
        <div className="space-y-2">
          <p className="text-base font-semibold text-slate-800 dark:text-slate-100">{currentNode.prompt}</p>
          <div className="grid gap-2">
            {currentNode.options.map((opt) => (
              <button
                key={opt.id}
                type="button"
                onClick={() => answerDecisionNode(tree, opt.id)}
                className="w-full text-left rounded-lg border px-3 py-2 text-sm transition hover:-translate-y-0.5 hover:shadow-sm bg-white dark:bg-slate-900 dark:border-slate-700 dark:text-slate-100"
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {result && (
        <div className="space-y-2">
          <p className="text-sm font-semibold text-emerald-600">{result.title}</p>
          <p className="text-sm text-slate-700 dark:text-slate-200">{result.summary}</p>
          <ul className="list-disc list-inside text-sm text-slate-700 dark:text-slate-200 space-y-1">
            {result.suggestions.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

